import { render, staticRenderFns } from "./business-premium-from.vue?vue&type=template&id=75b81e8f&scoped=true&"
import script from "./business-premium-from.vue?vue&type=script&lang=js&"
export * from "./business-premium-from.vue?vue&type=script&lang=js&"
import style0 from "./business-premium-from.vue?vue&type=style&index=0&id=75b81e8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b81e8f",
  null
  
)

export default component.exports